import { type ReactNode } from 'react';
import { Disclaimer } from '@repo/design-system-kit';
import { FormattedMessage, useIntl } from 'react-intl';
import type { PepRadioButtonProps } from '../pep-radio-button';
import { PepRadioButton } from '../pep-radio-button';

export interface PepWithDisclaimerProps extends PepRadioButtonProps {
  disclaimerMessage?: string;
}

export function PepWithDisclaimer({
  className,
  disclaimerMessage,
  title,
  subtitle,
  ...props
}: PepWithDisclaimerProps): ReactNode {
  const { formatMessage } = useIntl();

  return (
    <div className={className} data-testid="pep-with-disclaimer">
      <PepRadioButton
        className={props.value ? 'mb-16' : undefined}
        subtitle={
          subtitle || formatMessage({ id: 'customer-registration-kit.pep-ubo.description' })
        }
        title={title || formatMessage({ id: 'customer-registration-kit.pep-ubo.title' })}
        {...props}
      />

      {props.value ? (
        <Disclaimer.Block level="info">
          {disclaimerMessage || (
            <FormattedMessage id="customer-registration-kit.pep-ubo.disclaimer" />
          )}
        </Disclaimer.Block>
      ) : null}
    </div>
  );
}
